import DataTable, { RefObject, DataTableRenderFields } from './DataTable';

export default DataTable;
export type { RefObject, DataTableRenderFields };
